/* Product media modal (Dawn), turned into a product gallery with thumbnails (27 Oct 2026).
   Tap a photo on the PDP -> white full-screen gallery: one photo at a time fitted to
   the screen, opened on the one tapped, swipe / arrows / arrow keys between them, and
   a thumbnail strip below that marks the current photo and jumps on tap.
   Styles: assets/cs-zoom-gallery.css, all scoped to .cs-zg, which is only added here,
   so if this script fails Dawn's own modal still works. Videos and 3D are left out of
   the gallery (they play inline on the page). */
(function () {
  // Load the gallery styles with this script (only product pages load it).
  // Bump ZG_V when cs-zoom-gallery.css changes so the CDN serves the new copy.
  var ZG_V = '20261027c';
  var me = document.currentScript;
  if (me && me.src && !document.getElementById('cs-zg-css')) {
    var link = document.createElement('link');
    link.id = 'cs-zg-css';
    link.rel = 'stylesheet';
    link.href = me.src.replace(/product-modal\.js(\?.*)?$/, 'cs-zoom-gallery.css?v=' + ZG_V);
    document.head.appendChild(link);
  }
})();

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zgContainer = this.querySelector('[role="document"]');
        this.zgOnScroll = this.zgOnScroll.bind(this);
        this.zgOnKey = this.zgOnKey.bind(this);
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.zgOnKey);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Photos that are actually slides (videos / 3D / hidden variant photos are display:none).
      zgSlides() {
        return Array.prototype.filter.call(this.zgContainer.children, function (el) {
          return el.tagName === 'IMG' && getComputedStyle(el).display !== 'none';
        });
      }

      // Small version of a slide's photo for its thumbnail (Shopify CDN resizes on ?width=).
      zgThumbSrc(img) {
        var src = img.getAttribute('src') || '';
        return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1160') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160';
      }

      zgBuildUi() {
        if (this.zgUi) return;
        this.zgUi = true;
        var self = this;
        var dialog = this.querySelector('[role="dialog"]');
        var chev = function (d) {
          return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
        };
        this.zgPrev = document.createElement('button');
        this.zgPrev.type = 'button';
        this.zgPrev.className = 'cs-zg__nav cs-zg__nav--prev';
        this.zgPrev.setAttribute('aria-label', 'Previous photo');
        this.zgPrev.innerHTML = chev('M15 5l-7 7 7 7');
        this.zgNext = document.createElement('button');
        this.zgNext.type = 'button';
        this.zgNext.className = 'cs-zg__nav cs-zg__nav--next';
        this.zgNext.setAttribute('aria-label', 'Next photo');
        this.zgNext.innerHTML = chev('M9 5l7 7-7 7');
        this.zgThumbs = document.createElement('div');
        this.zgThumbs.className = 'cs-zg__thumbs';
        this.zgThumbs.setAttribute('role', 'group');
        this.zgThumbs.setAttribute('aria-label', 'Product photos');
        dialog.appendChild(this.zgPrev);
        dialog.appendChild(this.zgNext);
        dialog.appendChild(this.zgThumbs);

        this.zgPrev.addEventListener('click', function () { self.zgGo(self.zgIndex - 1); });
        this.zgNext.addEventListener('click', function () { self.zgGo(self.zgIndex + 1); });
        this.zgThumbs.addEventListener('click', function (e) {
          var t = e.target.closest('.cs-zg__thumb');
          if (t) self.zgGo(+t.getAttribute('data-i'));
        });
        // Dawn's media modal closes on ANY mouse pointerup inside it. In a gallery that
        // made a click on an arrow, a thumbnail or the photo shut it; only X / Esc close now.
        [this.zgPrev, this.zgNext, this.zgThumbs, this.zgContainer].forEach(function (el) {
          el.addEventListener('pointerup', function (e) { e.stopPropagation(); });
        });
        this.zgContainer.addEventListener('scroll', this.zgOnScroll, { passive: true });
      }

      // (Re)draw the thumbnails for the current slide set (variant changes can alter it).
      zgDrawThumbs(slides) {
        var self = this;
        this.zgThumbs.innerHTML = '';
        this.zgThumbs.hidden = slides.length < 2;
        slides.forEach(function (img, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cs-zg__thumb';
          b.setAttribute('data-i', k);
          b.setAttribute('aria-label', 'Photo ' + (k + 1) + ' of ' + slides.length);
          var t = document.createElement('img');
          t.src = self.zgThumbSrc(img);
          t.alt = '';
          t.loading = 'lazy';
          t.width = 60;
          t.height = 60;
          b.appendChild(t);
          self.zgThumbs.appendChild(b);
        });
      }

      zgGo(i, instant) {
        var slides = this.zgSlides();
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        var c = this.zgContainer;
        c.scrollTo({ left: i * c.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        this.zgSet(i, slides.length);
      }

      zgSet(i, n) {
        this.zgIndex = i;
        if (this.zgPrev) { this.zgPrev.disabled = i <= 0; this.zgPrev.hidden = n < 2; }
        if (this.zgNext) { this.zgNext.disabled = i >= n - 1; this.zgNext.hidden = n < 2; }
        if (!this.zgThumbs) return;
        var cur = null;
        Array.prototype.forEach.call(this.zgThumbs.children, function (b, k) {
          var on = k === i;
          b.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) cur = b;
        });
        // Keep the current thumbnail in view inside the strip (strip only, never the page).
        if (cur) {
          var s = this.zgThumbs, l = cur.offsetLeft, r = l + cur.offsetWidth;
          if (l < s.scrollLeft + 12) s.scrollLeft = l - 12;
          else if (r > s.scrollLeft + s.clientWidth - 12) s.scrollLeft = r - s.clientWidth + 12;
        }
      }

      zgOnScroll() {
        var c = this.zgContainer;
        if (!c.clientWidth) return;
        var n = this.zgSlides().length;
        var i = Math.max(0, Math.min(n - 1, Math.round(c.scrollLeft / c.clientWidth)));
        if (i !== this.zgIndex) this.zgSet(i, n);
      }

      zgOnKey(e) {
        if (!this.hasAttribute('open')) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.zgGo(this.zgIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.zgGo(this.zgIndex - 1); }
      }

      showActiveMedia() {
        var openedId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]:not([data-media-id="' + openedId + '"])').forEach(function (el) {
          el.classList.remove('active');
        });
        var activeMedia = this.querySelector('[data-media-id="' + openedId + '"]');
        if (activeMedia) activeMedia.classList.add('active');

        this.classList.add('cs-zg');
        this.zgBuildUi();
        var slides = this.zgSlides();
        this.zgDrawThumbs(slides);
        var i = slides.indexOf(activeMedia);
        if (i < 0) i = 0;
        // The tapped photo and its neighbours load now, not when they scroll in.
        [i - 1, i, i + 1].forEach(function (k) { if (slides[k]) slides[k].loading = 'eager'; });
        var self = this;
        this.zgIndex = -1;
        this.zgGo(i, true);
        // Once more after the modal has laid out, so the first frame is already the right photo.
        requestAnimationFrame(function () { self.zgGo(i, true); });
        document.addEventListener('keydown', this.zgOnKey);
        this.zgContainer.focus({ preventScroll: true });
      }
    }
  );
}
